import { createReducer } from '@reduxjs/toolkit';

import postLogin from '../../thunks/auth/login';
import logoOut from '../../actions/auth/auth';

const initialState = {
  loading: false,
  error: null
};

const loginReducer = createReducer(initialState, {
  [postLogin.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [postLogin.fulfilled]: (state) => ({
    ...state,
    loading: false,
  }),
  [postLogin.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload
  }),
  [logoOut]: () => {
    localStorage.removeItem('token');
    return initialState;
  }
});

export default loginReducer;
